var map = {
	"./dock/app-store.png": "2ee6",
	"./dock/home.png": "724e",
	"./dock/logout.png": "9d7d",
	"./dock/moon.png": "3d4f",
	"./dock/settings.png": "6466",
	"./dock/sun.png": "5741",
	"./fake-qr.png": "fd32",
	"./icon-app-bitcoin.svg": "36e4",
	"./icon-app-btcpay.svg": "3df6",
	"./icon-app-chaind.svg": "91ca",
	"./icon-app-lightning.svg": "0b4c",
	"./icon-app-lnd.svg": "a48b",
	"./icon-app-tor.svg": "3766",
	"./icon-block.svg": "9cbb",
	"./icon-dead-sd-card.svg": "f9a3",
	"./icon-modal-close.svg": "e8b5",
	"./icon-search.svg": "66d7",
	"./icon-system.svg": "381d",
	"./icon-wifi-1.svg": "d655",
	"./icon-wifi-2.svg": "dd79",
	"./icon-wifi-3.svg": "6033",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./migration-assistant/icon-error-warning.svg": "4a00",
	"./migration-assistant/icon-password.svg": "961a",
	"./migration-assistant/icon-power-btn-red.svg": "ca98",
	"./migration-assistant/icon-power-btn.svg": "b608",
	"./migration-assistant/icon-right-arrow.svg": "f24c",
	"./migration-assistant/icon-usb.svg": "cdff",
	"./migration-assistant/icon-warning.svg": "6d05",
	"./moon.svg": "3136",
	"./no-search-results.gif": "e8c4",
	"./sun.svg": "3f73",
	"./umbrel-qr-icon.svg": "366f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";